const NOT_AVAILABLE = "Not Available";

/**
 * Returns date as Month DD, YYYY format. If no date is provided returns Not Available
 * @param date
 * @param timezone
 */
export const format = (
  date: string | null | Date = null,
  timezone: string = "UTC",
): string => {
  if (!date) return NOT_AVAILABLE;

  const dateObj = typeof date === "string" ? new Date(date) : date;

  return dateObj.toLocaleDateString("en", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    timeZone: timezone,
  });
};

/**
 * Returns date in HH:MM AM/PM format. If no date is provided returns Not Available
 */
export const formatTime = (
  date: string | null | Date,
  timezone: string = "UTC",
): string => {
  if (!date) return NOT_AVAILABLE;

  const dateObj = typeof date === "string" ? new Date(date) : date;

  return dateObj.toLocaleTimeString("en", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: timezone,
  });
};
